<template>
  <div class="policy">
    <div class="title-wrap">
      <span class="title">政策查询</span>
    </div>
    <div class="content-wrap">
      <a href="#/policy-inquiries/person" class="policy-item" style="margin-bottom: 1.5vw">
        <span class="title">我是人才</span>
        <img src="@/assets/images/policy-icon-1.png" alt="" />
      </a>
      <a href="#/policy-inquiries/unit" class="policy-item">
        <span class="title">我是单位</span>
        <img src="@/assets/images/policy-icon-2.png" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyInquiries',
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
